<script lang="ts">
// SearchInput wires together three things that the official shadcn command-input.svelte
// doesn't combine: a search icon, a clear button, and CommandPrimitive.Input — all inside
// a single InputGroup row. We own this component rather than patching the shadcn one so
// the upstream component stays unmodified and reusable elsewhere.
import { Command as CommandPrimitive } from "bits-ui";
import * as InputGroup from "../ui/input-group/index.ts";
import { Button } from "../ui/button/index.ts";
import SearchIcon from "@lucide/svelte/icons/search";
import XIcon from "@lucide/svelte/icons/x";

let {
  ref = $bindable(null),
  value = $bindable(""),
  placeholder,
  onclear,
}: {
  ref?: HTMLInputElement | null;
  value?: string;
  placeholder?: string;
  onclear?: () => void;
} = $props();
</script>

<InputGroup.Root
  class="border-0! bg-transparent shadow-none rounded-none px-2 py-2 h-10"
>
  <InputGroup.Addon>
    <SearchIcon class="size-4 shrink-0 opacity-50" />
  </InputGroup.Addon>
  <CommandPrimitive.Input
    {value}
    {placeholder}
    data-slot="command-input"
    class="w-full text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
  >
    {#snippet child({ props })}
      <InputGroup.Input {...props} bind:value bind:ref />
    {/snippet}
  </CommandPrimitive.Input>
  {#if value}
    <InputGroup.Addon align="inline-end">
      <Button
        variant="ghost"
        size="icon-sm"
        type="button"
        class="text-muted-foreground"
        onclick={() => {
          value = "";
          onclear?.();
          ref?.focus();
        }}
        aria-label="Clear search"
      >
        <XIcon />
      </Button>
    </InputGroup.Addon>
  {/if}
</InputGroup.Root>
